import React, { useEffect, useRef, useState } from "react";
import { IndexUse } from "./IndexUse";
import { useDispatch } from "react-redux";
import Section_title from "../../common-components/section-title/Section_title";
import axios from "axios";

// Assuming 'maharashtra' is your GeoJSON file imported correctly
import { maharashtraGeoJson } from "./maharashtra.js";

const Country = () => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const { heattransport } = IndexUse();
  const apiKey = "AIzaSyCGySRnXP7VCuFGxzTFGawoyROcM3rfJKk";

  useEffect(() => {
    // Ensure Google Maps API is loaded
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
    script.async = true;
    script.defer = true;
    window.initMap = initMap;
    document.head.appendChild(script);

    // Cleanup the script on component unmount
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Initialize the Google Map
  const initMap = () => {
    const defaultCoords = { lat: 18.707344, lng: 76.013712 };
    loadMap(defaultCoords);
  };

  // Load Google Map
  const loadMap = (coords) => {
    const map = new window.google.maps.Map(mapRef.current, {
      center: coords,
      zoom: 6.5,
      zoomControl: false,
    });

    console.log(maharashtraGeoJson.features, "maharashtraGeoJson");

    // Plot Maharashtra Boundary (Polygon) on the map

    const polygonCoordinates = maharashtraGeoJson.features.map((coord) =>
      coord.geometry.coordinates.map((coor) => ({
        lat: coor[1], // Convert to {lat, lng}
        lng: coor[0],
      }))
    );

    const maharashtraPolygon = new window.google.maps.Polygon({
      paths: polygonCoordinates,
      strokeColor: "#FF0000",
      strokeOpacity: 0.5,
      strokeWeight: 1,
    });

    maharashtraPolygon.setMap(map);
  };

  return (
    <section className="content_body section_box">
      <div className="col-md-12">
        <Section_title title="Cab Heat Map (Maharashtra)" alltotal="" />
      </div>
      <div
        className="map"
        ref={mapRef}
        style={{ height: "500px", width: "100%" }}
      ></div>
    </section>
  );
};

export default Country;
